import React from 'react';
import PropTypes from 'prop-types';

import styles from './Stars.scss';

const Stars = ({count, className}) => {
	return (
		<ul className={`${styles.stars} ${className}`}>
			{[...Array(count)].map((x, i) =>
				<li key={i}>d</li>
			)}
		</ul>
	);
};
Stars.defaultProps = {};

//
Stars.propTypes = {
	count: PropTypes.number.isRequired,
	className: PropTypes.string.isRequired,
};

export default Stars;